// Reset Password Page Component
// LazySEM Frontend - Reset password page

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ResetPasswordForm } from '../../auth/components/PasswordReset/ResetPasswordForm';
import styles from './ResetPassword.module.css';

const ResetPassword: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  // Check if user is authenticated on mount only
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token && user) {
      navigate('/dashboard', { replace: true });
    }
    setInitialCheckDone(true);
  }, [user, navigate]);

  // Show loading only during initial check
  if (!initialCheckDone) {
    return (
      <div className={styles.resetPassword}>
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render if user is authenticated
  if (user) {
    return null;
  }

  return (
    <div className={styles.resetPassword}>
      <div className={styles.container}>
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPassword;